export const RE_DIGIT = new RegExp(/^\d+$/);
export const RE_EMAIL = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
